<template>
<div class="wallet-item mcf-border-color text-mcf-color pb-3">
  <div class=" w-100 h-100 d-flex px-3 pt-3">
    <div class="mr-3"><img :src="mcfWalletItem.eticketImg" alt="" class="image-panel-3"></div>
    <div class="flex-grow-1 d-flex flex-column flex-lg-row">
      <div class="w-100 ">
        <h6 class="mb-0">{{mcfWalletItem.eticketName}}</h6>
        <p v-if="mcfWalletItem.eticketType" class="mb-1 font-size-md text-mcf-secondary">{{eticketType}}</p>
        <p v-if="mcfWalletItem.eticketEndTime || mcfWalletItem.usedTime" :class="dayWoring" class="mb-1 font-weight-bold font-size-md">{{limitTime}}    {{limitDay}}</p>
        <p v-if="!mcfWalletItem.eticketEndTime && currentEticketTab=='usable'"  class="mb-1 font-weight-bold font-size-md">{{$t('mcfwallet.noLimit')}}</p>
        <p v-if="currentEticketTab === 'unused'" class="flex-grow-1 d-flex align-items-end mb-0 font-weight-bold font-size-md text-mcf-secondary">{{eticketStatus}}</p>
      </div>
    </div>
  </div>

      <div class=" flex-shrink-0 d-flex justify-content-end align-items-end mt-1 mx-n1 px-3" v-if="mcfWalletItem.eticketStatus === 1">
        <b-button @click="transferClick()" style="sm" v-if="mcfWalletItem.isTransfer" :class="isTransferClass" class="text-nowrap font-size-md px-2 mx-1">{{$t('mcfwallet.transfer')}}</b-button>
        <b-button @click="writeOffClick()" style="sm" v-if="mcfWalletItem.isOffline && mcfWalletItem.eticketStartTime < Math.round(+new Date())" :class="isOfflineClass" class="text-nowrap font-size-md px-2 mx-1" >{{$t('mcfwallet.offLine')}}</b-button>
        <b-button style="sm" v-if="mcfWalletItem.isOnline && mcfWalletItem.eticketStartTime < Math.round(+new Date())"  class="bg-customize border-customize text-nowrap font-size-md px-2 mx-1" @click="gostore">{{$t('mcfwallet.onLine')}}</b-button>
      </div>
</div>
</template>

<script>
import format from 'date-fns/format';
import { mapMutations, mapState } from 'vuex';

export default {
  props: {
    mcfWalletItem: Object,
  },
  computed: {
    ...mapState(['currentEticketTab']),
    ...mapState('memberSource', ['eticketTypeForWriteOff', 'eticketNoForWriteOff', 'eticketNameForWriteOff', 'isWriteOffClick', 'eticketSeqNoForWriteOff', 'isTransfer', 'eticketIsNeedWriteoffCode']),
    isTransferClass() {
      if (!this.mcfWalletItem.isOnline && !this.mcfWalletItem.isOffline) return 'bg-customize border-customize';
      return 'bg-white text-customize';
    },
    isOfflineClass() {
      if (!this.mcfWalletItem.isOnline) return 'bg-customize border-customize';
      return 'bg-white text-customize';
    },
    limitDay() {
      const now = Math.round(+new Date());
      const day = Math.floor((this.mcfWalletItem.eticketEndTime - now) / (24 * 3600 * 1000));
      if (day < 0 || this.currentEticketTab === 'unused') {
        return '';
      }
      if (this.mcfWalletItem.eticketStartTime > Math.round(+new Date())) return '';
      if (day <= 3) return this.$t('mcfwallet.limitDay', { day });
      return '';
    },
    limitTime() {
      if (this.currentEticketTab === 'unused') {
        if (this.mcfWalletItem.eticketStatus !== 3) return format(this.mcfWalletItem.usedTime, 'yyyy/MM/dd');
        return format(this.mcfWalletItem.eticketEndTime, 'yyyy/MM/dd');
      }
      if (this.mcfWalletItem.eticketStartTime > Math.round(+new Date())) return `${this.$t('mcfwallet.startTime')}: ${format(this.mcfWalletItem.eticketStartTime, 'yyyy/MM/dd HH:mm')}`;
      if (Math.floor((this.mcfWalletItem.eticketEndTime - Math.round(+new Date())) / (24 * 3600 * 1000)) > 3500) return this.$t('mcfwallet.noLimit');
      return format(this.mcfWalletItem.eticketEndTime, 'yyyy/MM/dd HH:mm');
    },
    // 剩餘時間少於3天時 紅字提醒
    dayWoring() {
      if (this.currentEticketTab === 'unused') return '';
      const now = Math.round(+new Date());
      const limitDay = Math.floor((this.mcfWalletItem.eticketEndTime - now) / (24 * 3600 * 1000));
      if (this.mcfWalletItem.eticketStartTime > Math.round(+new Date())) return '';
      if (limitDay <= 3) {
        return 'text-danger';
      }
      return '';
    },
    eticketType() {
      if (this.mcfWalletItem.eticketType === 1) return this.$t('mcfwallet.redeemorder');
      return 'Coupon';
    },
    eticketStatus() {
      switch (this.mcfWalletItem.eticketStatus) {
        case 2:
          return this.$t('mcfwallet.used');
        case 3:
          return this.$t('mcfwallet.expired');
        case 4:
          return `${this.$t('mcfwallet.istransfer')}  ${this.mcfWalletItem.transferTo}`;
        default:
          return '';
      }
    },
  },
  methods: {
    ...mapMutations('memberSource', ['setMemberSourceData']),
    gostore() {
      this.$emit('gostore');
    },
    getEticketType() {
      // 存eticketType
      this.setMemberSourceData({ id: 'eticketTypeForWriteOff', value: this.mcfWalletItem.eticketType });
      // 存eticketNo(兌禮序號orTXN流水號)
      this.setMemberSourceData({ id: 'eticketNoForWriteOff', value: this.mcfWalletItem.eticketNo });
      // 存eticketName
      this.setMemberSourceData({ id: 'eticketNameForWriteOff', value: this.mcfWalletItem.eticketName });
      this.setMemberSourceData({ id: 'eticketSeqNoForWriteOff', value: this.mcfWalletItem.eticketSeqno });
      this.setMemberSourceData({ id: 'eticketImg', value: this.mcfWalletItem.eticketImg });
      this.setMemberSourceData({ id: 'eticketDesc', value: this.mcfWalletItem.eticketDesc });
      this.setMemberSourceData({ id: 'eticketIsNeedWriteoffCode', value: this.mcfWalletItem.isrRimbursementCode });
    },
    writeOffClick() {
      this.getEticketType();
      this.setMemberSourceData({ id: 'isWriteOffClick', value: true });
    },
    transferClick() {
      this.getEticketType();
      this.setMemberSourceData({ id: 'isTransfer', value: true });
    },
  },
};
</script>

<style>
/* .wallet-item { background-color: #fff; border: solid 1px var(--light); border-radius: 0.5rem;} */
  .wallet-item { background-color: transparent ; border: none; border-bottom: solid 1px var(--light); border-radius: 0;}
@media screen and (min-width: 768px) {
  /* .mcf-dark .wallet-item { color: #fff;} */
}
</style>
